import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import CloseIcon from '../../public/static/images/close-modal.svg';
import Icon from '../Icon';

const BottomView = memo(
  ({ closeHandler, title, children, cy, additionalClasses }) => (
    <div className="bottom-view" data-cy={cy}>
      <div className={cn('bottom-view__header', additionalClasses)}>
        <span className="bottom-view__header-title">{title}</span>
        <div
          role="button"
          tabIndex="-1"
          onClick={closeHandler}
          onKeyPress={closeHandler}
          className="bottom-view__close-btn"
          data-cy={`${cy}-close`}
        >
          <Icon IconComponent={CloseIcon} height={15} width={15} />
        </div>
      </div>
      <div className="bottom-view__content">{children}</div>
    </div>
  )
);

BottomView.displayName = `BottomView`;

BottomView.propTypes = {
  closeHandler: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  cy: PropTypes.string,
  additionalClasses: PropTypes.string
};

export default BottomView;
